export default __webpack_public_path__ + "static/media/Shadow's Leggings of the Burning Temple.52a8dc7c.jpg";